import { ReactNode, forwardRef } from 'react';

interface InputLabelProps {
  children?: ReactNode;
  className?: string;
  name: string;
  required: boolean;
  text?: string;
  type: string;
}

const InputLabel = forwardRef<HTMLLabelElement, InputLabelProps>(
  ({ className, children, name, required, text, type }, ref) => {
    return (
      <label
        className={className || 'block mb-1'}
        htmlFor={`${type}_input_${name || type}`}
        ref={ref}
      >
        {children}
        {text}
        {required && ' *'}
      </label>
    );
  }
);

InputLabel.displayName = 'InputLabel';

export default InputLabel;
